module.exports = __webpack_public_path__ + "static/media/wallett.1d270062.svg";